import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light text-center">
      <h1 className="display-3 text-danger fw-bold mb-3">404</h1>
      <h4 className="text-secondary mb-4">Oops! Page not found</h4>
      <p className="mb-4">The page you’re looking for doesn’t exist or has been moved.</p>
      <Link to="/" className="btn btn-primary">
        Go Back Home
      </Link>
    </div>
  );
};

export default NotFound;
